import { SAVE_DEFAULT_CARRIERS_FAILURE, SAVE_DEFAULT_CARRIERS_REQUEST, SAVE_DEFAULT_CARRIERS_REST, SAVE_DEFAULT_CARRIERS_SUCCESS } from "@/redux/actions/RateManagement/SaveDefaultCarriers";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const saveDefaultCarriersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_DEFAULT_CARRIERS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case SAVE_DEFAULT_CARRIERS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case SAVE_DEFAULT_CARRIERS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case SAVE_DEFAULT_CARRIERS_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default saveDefaultCarriersReducer;
